<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-22T23:15:13+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe
@Last modified by:   tom
@Last modified time: 2019-06-12T18:08:02+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template>

  <section class="pb-0">
    <b-jumbotron id="intro-jumbo" bg-variant="dark" class="pt-4 pb-4">
      <b-container>
        <b-row id="jmb-content" align-v="center">

          <b-col md="7" class="mb-2">
            <embedvideo/>
          </b-col>

          <b-col id="info-block">
            <h3 class="pt-2" v-html="$t('intro.2.title')"/>
            <uli
              :nritems="5"
              color="light"
              size="sm"
              class="mt-4"
              labelkey="intro.2.list"
              tooltipicon
              tooltipkey="intro.2.tooltip"/>

            <b-row id="info-text" class="mt-4" align-v="end">
              <b-col cols="9">
                <b-button
                  id="preorder-button"
                  to="/puck"
                  size=""
                  variant="secondary"
                  class="mb-4"
                  v-html="$t('intro.more') "/>
              </b-col>
              <b-col>
                <router-link to="/puck">
                  <lzimg
                    id="puckimg"
                    :src="assetUrl('img/preorder/puck-red-s.png')"
                    fluid
                    width="100"
                    height="100"/>
                </router-link>
              </b-col>
            </b-row>

            <!-- <router-link :to="{name:'puck_order'}" class="">
              <preorder/>
            </router-link> -->

          </b-col>
        </b-row>

      </b-container>
    </b-jumbotron>
  </section>

</template>

<script>

import Vue from 'vue'

import VideoTrailer from '@/components/home/EmbedVideo'
Vue.component('embedvideo', VideoTrailer)

export default {
  name: 'Intro'
}

</script>

<style lang="scss">

  #intro-jumbo {
    background-image: asset('video/PuckbyQrespi-poster_bg-m.jpg');
    background-size: cover;
    #jmb-content {
      background: linear-gradient(to right, rgba(45,35,12,0) 0%, rgba(45,35,12,1) 85%);
      padding: 0;
      a {
        text-decoration: none;
      }
    }
  }

</style>
